import { guideSteps } from '@/mocks/communityData';
import SectionHeading from './SectionHeading';

export default function Guide() {
  return (
    <section id="guide" className="bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[0.85fr_1.15fr]">
          <div>
            <SectionHeading
              eyebrow="新手指引"
              title="第一次来？跟着四步融入这个圈子"
              desc="看料社欢迎每一个新人。无论你是刚入坑的小白，还是混迹多年的老手，四步就能找到自己的位置，开始畅快交流。"
            />
            <div className="mt-6 flex flex-wrap gap-3">
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1.5 text-sm text-accent-800">
                <i className="ri-eye-line"></i> 新人友好
              </span>
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1.5 text-sm text-secondary-900">
                <i className="ri-message-2-line"></i> 氛围友善
              </span>
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1.5 text-sm text-primary-800">
                <i className="ri-seedling-line"></i> 共同成长
              </span>
            </div>
          </div>

          <ol className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {guideSteps.map((s, i) => (
              <li
                key={s.title}
                className="relative rounded-xl border border-background-200/80 bg-background-100 p-5"
              >
                <span className="absolute right-4 top-4 font-heading text-4xl font-bold text-background-300/70">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className={`${s.icon} text-xl`}></i>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}